/// <reference path="./../Container/FlexContainer.ts" />
namespace HA.Core.HTML.Menu {
    export class AppMenuItem extends FlexContainer {
        /**
         *
         * @returns ItemNavigation
         */
        protected getNavigationService() {
            return this.getService("ha.service.webpage");
        }

        /**
         * @param data
         */
        protected initialize(data: Map<string, any>) {
            super.initialize(data);
            this.addClass("mi");
            const ic = new FlexContainer();
            const icon = new I();
            if (Array.isArray(data.get("i"))) {
                icon.addClasses(data.get("i"));
            } else {
                icon.addClass(data.get("i"));
            }
            ic.addClass("iconc");
            ic.appendChild(icon);
            this.appendChild(ic);
            this.appendChild(new TextField(data.get("n")));
        }
    }
}
